<!-- Shared tab content — rendered in both collapsed and expanded (splitter) layouts -->
<ng-template #tabContent>
  <bai-tab-bar
    [tabs]="tabsForDisplay()"
    [activeTabId]="activeTab()"
    (tabSelect)="activeTab.set($any($event))"
  />
  <div class="flex-1 min-h-0 min-w-0 flex flex-col">
    @switch (activeTab()) {
      @case ('client-chat') {
        <div class="flex-1 min-h-0 min-w-0 flex flex-col bg-gray-50 border-r border-gray-200">
          <bai-client-chat-demo class="flex-1 min-h-0 min-w-0" />
        </div>
      }
      @case ('actions') {
        <div class="bai-tab-pane">
          <bai-client-actions class="block p-4" />
        </div>
      }
      @case ('ai-insights') {
        <div class="bai-tab-pane">
          <bai-client-ai-insights />
        </div>
      }
      @case ('resources') {
        <div class="bai-tab-pane">
          <bai-client-resources />
        </div>
      }
      @case ('finances') {
        <div class="bai-tab-pane">
          <bai-client-finances />
        </div>
      }
      @case ('accounts') {
        <div class="bai-tab-pane">
          <bai-client-accounts />
        </div>
      }
      @case ('journey') {
        <div class="bai-tab-pane">
          <bai-client-journey />
        </div>
      }
      @case ('quality') {
        <div class="bai-tab-pane">
          <bai-client-quality />
        </div>
      }
      @case ('profile') {
        <div class="bai-tab-pane bai-tab-pane--surface">
          <div class="p-4">
            <bai-client-profile />
          </div>
        </div>
      }
      @case ('documents') {
        <div class="bai-tab-pane">
          <bai-client-documents />
        </div>
      }
    }
  </div>
</ng-template>

<bai-brightai-layout>
  <bai-client-list column1 [collapsed]="collapsed()" />
  <div column2 class="flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden">

    @if (copilotCollapsed()) {
      <!-- Collapsed: left pane fills full width, narrow strip holds expand button -->
      <div class="flex flex-row h-full" [style.height]="splitterHeight">
        <div class="flex-1 min-w-0 flex flex-col min-h-0">
          <ng-container *ngTemplateOutlet="tabContent" />
        </div>
        <!-- Collapsed copilot strip -->
        <div class="bai-copilot-collapsed-strip">
          <button
            type="button"
            class="bai-copilot-strip-btn"
            (click)="toggleCopilot()"
            aria-label="Expand BrightAI Copilot"
          >
            <i class="pi pi-angle-left"></i>
          </button>
          <i class="pi pi-microchip-ai bai-copilot-strip-icon" aria-hidden="true"></i>
        </div>
      </div>
    } @else {
      <!-- Expanded: normal splitter -->
      <p-splitter
        [panelSizes]="[70, 30]"
        [minSizes]="[30, 15]"
        layout="horizontal"
        stateKey="bai-my-clients-content-splitter-v2"
        stateStorage="local"
        styleClass="bai-content-splitter border-0"
        [style]="{ height: splitterHeight }"
      >
        <ng-template #panel>
          <div class="h-full w-full flex flex-col min-h-0 min-w-0">
            <ng-container *ngTemplateOutlet="tabContent" />
          </div>
        </ng-template>
        <ng-template #panel>
          <div class="h-full w-full flex flex-col min-h-0 min-w-0">
            <p-menubar
              [model]="copilotPaneMenuItems()"
              styleClass="bai-tab-menubar rounded-none border-x-0 border-t-0 border-b border-gray-200 bg-transparent w-full"
            />
            <div class="bai-copilot-pane-content">
              <lib-chat class="flex-1 min-h-0 min-w-0"></lib-chat>
            </div>
          </div>
        </ng-template>
      </p-splitter>
    }

  </div>
</bai-brightai-layout>
